export default __webpack_public_path__ + "static/media-release-hero-f837b999cd2c7c37df49f2c0e3f58d6c.jpg";